import { Reveal, Chapter } from "@/components/Reveal";
import { scrollToId } from "@/lib/scroll";

const SERVICES = [
  {
    n: "01",
    title: "Mystery Shopper Audits",
    copy: "Independent and detailed evaluations of real guest experiences covering service delivery, hospitality standards, culinary execution and team performance.",
    items: [],
  },
  {
    n: "02",
    title: "Labor Cost Review",
    copy: "Detailed manpower and roster analysis designed to improve productivity, reduce unnecessary labor costs and strengthen organizational structure.",
    items: [],
  },
  {
    n: "03",
    title: "Bespoke Training",
    copy: "Customized hospitality training designed around your team, your standards and your guests.",
    items: [
      "Wine Education",
      "Upselling",
      "Luxury Table Service",
      "Sequence of Service",
      "Guest Engagement",
      "Leadership Development",
      "Performance Evaluation",
    ],
  },
  {
    n: "04",
    title: "Operational Review",
    copy: "Strategic reviews designed to strengthen performance across every operational layer.",
    items: [
      "Purchasing Efficiency",
      "Supplier Agreements",
      "Inventory Controls",
      "Service Standards",
      "Labor Productivity",
      "Revenue Opportunities",
      "HR Structure",
    ],
  },
];

const Advisory = () => (
  <section id="advisory" data-testid="advisory-section" className="bg-ivory py-28 lg:py-40">
    <div className="max-w-[1600px] mx-auto px-6 lg:px-12">
      <Reveal>
        <Chapter number="05" label="Hospitality Advisory" />
      </Reveal>
      <div className="grid lg:grid-cols-2 gap-10 items-end mb-16 lg:mb-24">
        <Reveal delay={0.1}>
          <h2 className="font-serif text-4xl sm:text-5xl lg:text-6xl font-light leading-[1.08] text-ink">
            Beyond <span className="italic text-bronze">Placement</span>
          </h2>
        </Reveal>
        <Reveal delay={0.2}>
          <p className="text-sm text-ink/60 leading-relaxed max-w-md lg:justify-self-end">
            Our relationship with clients does not need to end once a position is filled. BR
            Hospitality provides targeted advisory services designed to strengthen operational
            performance.
          </p>
        </Reveal>
      </div>

      <div className="border-t border-ink/10">
        {SERVICES.map((s, i) => (
          <Reveal key={s.n} delay={0.05 * i}>
            <div
              data-testid={`advisory-block-${s.n}`}
              className="group grid lg:grid-cols-12 gap-6 lg:gap-10 py-12 lg:py-16 border-b border-ink/10 items-start hover:bg-sand/40 transition-colors duration-700 px-2 lg:px-6"
            >
              <div className="lg:col-span-1">
                <span className="font-serif italic text-bronze text-xl">{s.n}</span>
              </div>
              <div className="lg:col-span-4">
                <h3 className="font-serif text-3xl lg:text-4xl font-light text-ink group-hover:text-bronze transition-colors duration-500">
                  {s.title}
                </h3>
              </div>
              <div className="lg:col-span-4">
                <p className="text-sm text-ink/60 leading-relaxed">{s.copy}</p>
              </div>
              <div className="lg:col-span-3">
                {s.items.length > 0 && (
                  <ul className="space-y-1.5">
                    {s.items.map((it) => (
                      <li key={it} className="text-[11px] tracking-[0.12em] uppercase text-ink/50">
                        {it}
                      </li>
                    ))}
                  </ul>
                )}
              </div>
            </div>
          </Reveal>
        ))}
      </div>

      <Reveal delay={0.2}>
        <button
          data-testid="advisory-cta"
          onClick={() => scrollToId("#contact")}
          className="mt-14 text-[11px] tracking-[0.25em] uppercase px-8 py-4 border border-ink text-ink hover:bg-ink hover:text-ivory transition-all duration-500"
        >
          Explore Advisory Services
        </button>
      </Reveal>
    </div>
  </section>
);

export default Advisory;
